import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    StudyTeamMemberProps,
    LoadStudyTeamMemberById,
    setStudyTeamMemberView,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

const View = ({
    teamMemberId = null,
}: StudyTeamMemberProps) => {
    const study = useSelector((state: StoreType) => state.study.studyView)
    const teamMember = useSelector((state: StoreType) => state.studyTeamMember.teamMemberView)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        setLoadState(PENDING)
        LoadStudyTeamMemberById(teamMemberId, study.id)
        .then((res) => {
            dispatch(setStudyTeamMemberView(res))
            setLoadState(IDLE)
        })
    }, [])

    if (!teamMember) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{`${lang.viewTeamMember} # ${teamMember.id || ""}`}</PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                <Form />
            </PageContent>
        </Container>
    )
}
export default View
